import React, { useState, useEffect } from 'react'
import { Col, Row, Form, Spinner } from 'react-bootstrap'
import { APIurls, Axios } from '../../constants'
import { useFormik } from 'formik'
import { basicSchema } from '../../schemas'
import toast from 'react-hot-toast'
import Loader from './../../components/Loader'

const ContactUs = () => {



    const [ranges, setRange] = useState([])
    const [loading, setLoading] = useState(false)
    const [Err, setErr] = useState([]);
    const [char, setChar] = useState(0)


    useEffect(() => {
        getPaymentRange()
        window.scroll(0, 0);
    }, []);


    const getPaymentRange = async () => {

        try {
            const res = await Axios.get(APIurls.getRang);
            if (res && res?.data) {
                setRange(res?.data?.data)
            } else {
                setRange([])
            }

        } catch (error) {
            toast.error('issue in query');
        }
    }



    const onSubmit = async (values, actions) => {
        try {
            setLoading(true);
            const res = await Axios.post(APIurls.postRequest, values);
            setLoading(false);
            if (res && res?.data?.statusCode === 200) {
                actions?.resetForm()
            } else {
                toast.error('error in query...');
                actions?.resetForm()
            }

        } catch (error) {
            setErr(error?.response?.errors);
            console.log("error", error)
        } finally {
            setLoading(false);
        }
    }

    const { values, errors, touched, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: { name: '', email: '', contact: '', website: '', communication_medium: '', content: '', platform: '', budget_range_id: '', project_summary: '', news_latter: '' },
        validationSchema: basicSchema,
        onSubmit,
    })
    return (
        <div className='contactUs'>
            {loading ? <Loader /> :
                <>
                    <Row>
                        <Col xs={12} sm={12} md={10} lg={8} className='mx-auto'>
                            <h1 data-aos="fade-down">Tell us about your project</h1>
                            <p data-aos="fade-down">Hi there! We’re thrilled to hear about your project. Fill out the form below and share your vision with us, and let Pixel Motus turn it into reality. Your ideas deserve the best, and we’re here to make it happen!</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={10} lg={10} className='mx-auto'>
                            <Form onSubmit={handleSubmit} autoComplete='off'>
                                <Row>
                                    <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                                        <Form.Group className="mb-4" >
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control type="text" placeholder="John Doe" id="name" value={values?.name} onChange={handleChange} />
                                            {errors?.name || touched.name ? <span className='text-danger'>{errors?.name}</span> : ''}

                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                                        <Form.Group className="mb-4" >
                                            <Form.Label>Email Address</Form.Label>
                                            <Form.Control type="email" placeholder="info@example.com" id="email" value={values?.email} onChange={handleChange} />
                                            {errors?.email || touched?.email ? <span className='text-danger'>{errors?.email}</span> : ''}
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                                        <Form.Group className="mb-4" >
                                            <Form.Label>Company Website <small style={{ color: '#909093' }}>(Optional)</small></Form.Label>
                                            <Form.Control type="text" placeholder="www.info.com" id={"website"} value={values?.website} onChange={handleChange} />
                                            {errors?.website || <span className='text-danger'>{errors?.website}</span>}
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                                        <Form.Group className="mb-4" >
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control type="number" placeholder="(123)-1233-12" id={"contact"} value={values?.contact} onChange={handleChange} />
                                            {errors?.contact || touched?.contact ? <span className='text-danger'>{errors?.contact}</span> : ''}
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                                        <Form.Group className="mb-4" >
                                            <Form.Label>Communication Medium <small style={{ color: '#909093' }}>(Optional)</small></Form.Label>
                                            <Form.Control type="text" placeholder="E.g Skype, Google Meet, Slack" id={"communication_medium"} value={values?.communication_medium} onChange={handleChange} />
                                            {errors?.communication_medium || touched?.communication_medium ? <span className='text-danger'>{errors?.communication_medium}</span> : ''}
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                                        <Form.Group className="mb-4" >
                                            <Form.Label>How Did You Hear About Us ? <small style={{ color: '#909093' }}>(Optional)</small></Form.Label>
                                            <Form.Control type="text" placeholder="Name Of Platform" id={"platform"} value={values?.platform} onChange={handleChange} />
                                            {errors?.platform || touched?.platform ? <span className='text-danger'>{errors?.platform}</span> : ''}
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6} xl={4}>
                                        <Form.Group className="mb-4" >
                                            <Form.Label>Select a Project Budget</Form.Label>
                                            <Form.Select id={"budget_range_id"} onChange={handleChange}>
                                                <option>Select Budget Range</option>
                                                {ranges?.map((range, r) => (
                                                    <option value={range?.id} key={r}>{range?.range}</option>
                                                ))}
                                            </Form.Select>
                                            {errors?.budget_range_id || touched?.budget_range_id ? <span className='text-danger'>{errors?.budget_range_id}</span> : ''}
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6} xl={8}>
                                        <Form.Group className="mb-4" >
                                            <Form.Label>Content</Form.Label>
                                            <Form.Control type="text" placeholder="" id={"content"} value={values?.content} onChange={handleChange} />
                                            {errors?.content || touched?.content ? <span className='text-danger'>{errors?.content}</span> : ''}
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Form.Group className="mb-4" >
                                            <Form.Label>How Can We Help? Project Details Please</Form.Label>
                                            <Form.Control as="textarea" rows={8} id={"project_summary"} onChange={handleChange} value={values?.project_summary} />
                                            {errors?.project_summary || touched?.project_summary ? <span className='text-danger'>{errors?.project_summary} </span> : ''}
                                            <Form.Text className="text-white" style={{ float: "right" }}>{values?.project_summary?.length < 100 ? `At least  ${100 - values?.project_summary?.length} Characters` : ''}  </Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={7} className='mx-auto'>
                                        <Form.Group className="mb-4" >
                                            <Form.Check
                                                type={'checkbox'}
                                                id='news_latter'
                                                value='Yes'
                                                checked={values?.news_latter === true}
                                                onChange={(e) => {
                                                    setFieldValue('news_latter', e.target.checked ? true : false); // Update value as 'Yes' or empty string
                                                }}
                                                label={<><span>Would You Like To Sign up for announcements and our quarterly newsletter ?</span></>}
                                            />
                                            {errors?.news_latter || <span className='text-danger'>{errors?.news_latter}</span>}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6} sm={6} md={4} lg={3} xl={3} xxl={3} className='mx-auto text-center mt-1'>
                                        {loading ?

                                            <button className='getInto w-100' type='submit'>
                                                <Spinner animation="border" role="status"></Spinner>
                                            </button>
                                            :
                                            <button className='getInto w-100' type='submit'>Submit</button>
                                        }

                                    </Col>
                                </Row>

                            </Form>
                        </Col>
                    </Row>
                </>

            }
        </div>

    )
}

export default ContactUs